import { TableCell, withStyles } from '@material-ui/core';

const PlainTableCell = withStyles({
  root: {
    border: 'none'
  }
})(TableCell);

export { PlainTableCell };
